module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sort.selected),
      expression: "sort.selected"
    }],
    staticClass: "form-control auto-width",
    staticStyle: {
      "margin-bottom": "30px"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sort.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeSort]
    }
  }, _vm._l((_vm.sort.items), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n        " + _vm._s(option.label) + "\n      ")])
  })), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query.kerkif),
      expression: "query.kerkif"
    }],
    staticClass: "form-control auto-width",
    attrs: {
      "placeholder": "Keresés...",
      "id": "kereso"
    },
    domProps: {
      "value": (_vm.query.kerkif)
    },
    on: {
      "keyup": _vm.changeSerach,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query.kerkif = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "competition-items"
  }, _vm._l((_vm.forms), function(form, i) {
    return _c('div', {
      staticClass: "competition-item-outer"
    }, [_c('div', {
      staticClass: "competition-item"
    }, [_c('div', [_c('i', {
      staticClass: "fa fa-file-o"
    }), _vm._v("\n              " + _vm._s(form.name) + "\n            "), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(form.subname))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "center",
        "flex-wrap": "wrap",
        "flex-direction": "column"
      }
    }, [_c('div', [(parseInt(form.fill_amount) == 0 && form.fillable == 1) ? _c('router-link', {
      staticClass: "button",
      attrs: {
        "to": {
          path: '/palyazatra_jelentkezes/?id=' + form.id
        }
      }
    }, [_vm._v("Jelentkezem")]) : _vm._e(), _vm._v(" "), (parseInt(form.fill_amount) > 0) ? _c('router-link', {
      staticClass: "button",
      attrs: {
        "to": {
          path: '/palyazatra_jelentkezes/?id=' + form.id
        }
      }
    }, [_vm._v("Pályázatom")]) : _vm._e(), _vm._v(" "), (form.link != '') ? _c('a', {
      staticClass: "button",
      attrs: {
        "target": "_blank",
        "title": "Bővebben",
        "href": form.link
      }
    }, [_vm._v("Bővebben")]) : _vm._e(), _vm._v(" "), (form.show_contact_data == 1 && form.contact_data != null && form.contact_data != '') ? _c('a', {
      staticClass: "button only-icon v2",
      staticStyle: {
        "margin-left": "5px",
        "padding": "0px 15px"
      },
      attrs: {
        "href": "javascript:void(0)",
        "title": "Kapcsolattartó adatai"
      },
      on: {
        "click": function($event) {
          _vm.form_contact_data = JSON.parse(form.contact_data);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle",
      staticStyle: {
        "font-size": "20px",
        "line-height": "37px"
      }
    })]) : _vm._e()], 1), _vm._v(" "), (form.info_pdf_file != '') ? _c('a', {
      staticClass: "button",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "target": "_blank",
        "href": 'assets/pdf/' + form.info_pdf_file + '?v=' + new Date().getTime(),
        "title": "Felhívás"
      }
    }, [_vm._v("\n                Felhívás\n              ")]) : _vm._e()])])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "breadcrumbs clearfix"
  }, [_c('div', {
    staticClass: "result"
  }, [_vm._v("\n        Összesen "), _c('span', [_vm._v(_vm._s(_vm.pcs))]), _vm._v(" találat.\n      ")])])]), _vm._v(" "), (_vm.form_contact_data != '') ? _c('FormContactData', {
    attrs: {
      "data": _vm.form_contact_data
    },
    on: {
      "onClose": function($event) {
        _vm.form_contact_data = ''
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-124c31e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/scholarship.vue
// module id = 328
// module chunks = 0